module.exports = __webpack_public_path__ + "static/media/Vegas_Golden_Knights.f7a14f0a.svg";